import React, { useMemo } from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  useRowSelect,
} from "react-table";
//import { GlobalFilter } from "./GlobalFilter";
import { COLUMNS } from "./UserColumns";
import { Checkbox } from "./Checkbox";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import "./Table.css";

export const UserTable = ({ users, admins, setSelection }) => {
  const columns = useMemo(() => COLUMNS, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    selectedFlatRows,
    state,
    gotoPage,
    pageCount,
  } = useTable(
    {
      columns,
      data: users,
      initialState: { pageSize: 8, hiddenColumns: ["first_name", "last_name"] },
      autoResetPage: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection;",
            width: "50",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <Checkbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
              <Checkbox {...row.getToggleRowSelectedProps()} />
            ),
          },
          ...columns,
        ];
      });
    }
  );

  React.useEffect(() => {
    // Bubble up the selection to the parent component
    setSelection(selectedFlatRows.map((row) => row.original));
  }, [setSelection, selectedFlatRows]);

  const { pageIndex } = state;

  const page_buttons = [];
  var i;
  for (i = 0; i < pageCount; i++) {
    const page = i;
    page_buttons.push(
      <button
        key={i}
        className="page_button"
        onClick={() => gotoPage(page)}
        disabled={page === pageIndex}
      >
        {page + 1}
      </button>
    );
  }

  function isAdmin(username) {
    if (admins.includes(username)) {
      return "admin";
    }
    return null;
  }

  return (
    <div className="table_area">
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  width={column.width}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <ArrowDropDownIcon style={{ height: "23px" }} />
                      ) : (
                        <ArrowDropUpIcon style={{ height: "23px" }} />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr
                onClick={() => {
                  row.toggleRowSelected();
                }}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>
                      {cell.render("Cell", { isAdmin: isAdmin })}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination_area">{page_buttons}</div>
    </div>
  );
};
